import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-dusty-rose-100 pt-2 pb-10 px-4" data-id="element-83">
      {/* Decorative Background Blobs */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-dusty-rose-300 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" data-id="element-84"></div>
      <div className="absolute top-0 right-0 w-72 h-72 bg-gold-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" style={{
      animationDelay: '2s'
    }} data-id="element-85"></div>
      <div className="absolute -bottom-8 left-20 w-72 h-72 bg-cream-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-blob" style={{
      animationDelay: '4s'
    }} data-id="element-86"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-87">
        <FadeIn delay={0.1} data-id="element-88">
          <span className="inline-block py-0.5 px-3 rounded-full bg-white/60 text-burgundy-700 text-[10px] font-semibold tracking-wide mb-4 uppercase border border-white/40 backdrop-blur-sm" data-id="element-89">
            Para mamás que quieren criar con propósito
          </span>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-90">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-burgundy-900 leading-tight mb-6" data-id="element-91">
            Entendé a tu hijo de una vez por todas —{' '}
            <span className="italic font-normal text-burgundy-700" data-id="element-92">
              sin culpa, sin adivinar y sin necesitar saber nada de astrología
            </span>
          </h1>
        </FadeIn>

        {/* Product Mockup Image */}
        <FadeIn delay={0.3} data-id="element-93">
          <div className="relative w-full max-w-md mx-auto mb-8" data-id="element-94">
            <div className="absolute inset-0 bg-dusty-rose-200 rounded-full blur-3xl opacity-30 scale-110" data-id="element-95"></div>
            <img src="https://cdn.magicpatterns.com/uploads/sZgFRJukNGp9Gpmh2r2aCi/Gemini_Generated_Image_1g2o3b1g2o3b1g2o.png" alt="CÓDIGO HIJO — Colección completa: 6 Tomos + 3 Bonus" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-96" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-97">
          <p className="text-base md:text-lg text-burgundy-800/80 mb-6 max-w-2xl mx-auto leading-relaxed" data-id="element-98">
            La colección completa que traduce la carta natal de tu hijo en
            respuestas concretas, cálidas y accionables para criar con calma
            todos los días.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-99">
          <div className="flex flex-col items-center" data-id="element-100">
            <motion.button onClick={() => {
            document.getElementById('cta-final')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-gold-300 text-burgundy-900 font-bold py-4 px-8 rounded-full shadow-xl hover:shadow-2xl hover:bg-gold-400 transition-all text-lg md:text-xl w-full md:w-auto border border-gold-400/50 cursor-pointer" data-id="element-101">
              🌟 QUIERO MI COLECCIÓN
            </motion.button>
            <p className="mt-4 text-sm text-burgundy-700/70 font-medium" data-id="element-102">
              Descarga inmediata · Acceso de por vida · Sin suscripciones
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}